import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {OnChange} from '@ng-app-framework/core';
import {ModalDirective} from 'ngx-bootstrap';
export class PromptModalComponent {

     promptModal: ModalDirective;
     size: string = 'sm';

    @OnChange  isModalShown: boolean = false;
     isModalShownChange             = new EventEmitter<boolean>();

     isBackdropStatic = true;

     keyboard = true;
/**
 * @return {?}
 */
show() {
        this.isModalShown = true;
    }
/**
 * @return {?}
 */
hide() {
        this.isModalShown = false;
    }
/**
 * @return {?}
 */
getConfig() {
        let /** @type {?} */ config = {
            show: true,
            keyboard: this.keyboard
        };

        if (this.isBackdropStatic) {
            config['backdrop'] = 'static';
        }

        return config;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-modal',
    template: `
        <div *ngIf="isModalShown" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" bsModal #promptModal="bs-modal"
             [config]="getConfig()">
            <div class="modal-dialog modal-{{size}}">
                <div class="modal-content">
                    <ng-content select="prompt-header"></ng-content>
                    <ng-content select="prompt-body"></ng-content>
                    <ng-content select="prompt-footer"></ng-content>
                </div>
            </div>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'promptModal': [{ type: ViewChild, args: ['promptModal', ] },],
'size': [{ type: Input },],
'isModalShown': [{ type: Input },],
'isModalShownChange': [{ type: Output },],
'isBackdropStatic': [{ type: Input },],
'keyboard': [{ type: Input },],
};
}

function PromptModalComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptModalComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptModalComponent.ctorParameters;
/** @type {?} */
PromptModalComponent.propDecorators;
/** @type {?} */
PromptModalComponent.prototype.promptModal;
/** @type {?} */
PromptModalComponent.prototype.size;
/** @type {?} */
PromptModalComponent.prototype.isModalShown;
/** @type {?} */
PromptModalComponent.prototype.isModalShownChange;
/** @type {?} */
PromptModalComponent.prototype.isBackdropStatic;
/** @type {?} */
PromptModalComponent.prototype.keyboard;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
